import { AnswerWithScore } from './AnswerWithScore';

export default AnswerWithScore;
